import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import React from 'react';
import { store, history} from './store';

import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';

import App from './components/App';
import SimpleReactLightbox from 'simple-react-lightbox'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import './style/main.css';


ReactDOM.render((
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <SimpleReactLightbox>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </SimpleReactLightbox>
    </ConnectedRouter>
  </Provider>

), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js